import { useNavigate } from 'react-router-dom';

import { INVALID_SESSION_MESSAGE, UNAUTHENTICATED_MESSAGE } from '../api/http';
import { Constants } from '../constants/login';
import {
  getLocalStorageToken,
  removeLocalStorageToken,
} from '../helpers/localStorage';
import { queryClient } from '../lib/queryClient';

interface UseErrorMessageHook {
  getErrorMessage(error: unknown, navigateHome?: boolean): string;
  logDevError(error: unknown): void;
}

export default function useErrorMessage(): UseErrorMessageHook {
  const navigate = useNavigate();

  // "Usuário não autenticado" only ends a session that exists: during MFA the
  // pending token lives under another key and the Mfa page handles it itself.
  const isSessionEnded = (message: string): boolean =>
    message === INVALID_SESSION_MESSAGE ||
    (message === UNAUTHENTICATED_MESSAGE && getLocalStorageToken() !== null);

  const getErrorMessage = (error: unknown, navigateHome?: boolean): string => {
    if (error instanceof Error) {
      if (error.name === 'TypeError') {
        return 'Algo deu errado, tente novamente';
      }
      if (isSessionEnded(error.message)) {
        removeLocalStorageToken();
        queryClient.clear();
        navigate('/login');
        return Constants.sessionExpired;
      }
      if (navigateHome) {
        navigate('/home');
      }
      return error.message;
    }
    return 'Algo deu errado, tente novamente';
  };

  const logDevError = (error: unknown): void => {
    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.warn(error);
    }
  };

  return {
    getErrorMessage,
    logDevError,
  };
}
